export default __webpack_public_path__ + "images/88d3e5b8cd7c7d7f4ced1bd62fe84ac9-disaster_relief.jpg";